import { ol_Feature, ol_geom, ol_GeometryType } from "@omnia/exports/openlayers";
import { Datalayer, DatalayersMap } from "../../../omnia";
import { cleanupLayer } from "../../../utils";

export class SplitOperation {

    private _splittingFeature: ol_Feature;

    constructor(private map: DatalayersMap, private layer: Datalayer, private topo: omnia.map.IMapTopologyService) {
    }

    start(type: ol_GeometryType = "LineString") {

        this.map.startDrawingNewFeature(this.layer, type, {

            drawStartWatcher: feature => {
                this._splittingFeature = feature;
            }

        });

    }

    stop() {

        if (this._splittingFeature) {
            this.layer.removeFeature(this._splittingFeature, true)
            this._splittingFeature = null;
        }

    }

    commit() {

        const feature = <ol_Feature>this.map.commitEdit();

        if (omnia.isObject(feature)) {

            let geom: ol_geom.Geometry = feature.getGeometry()

            this.commitInternal(geom)

            cleanupLayer(this.layer)

        }

        return true
    }


    private commitInternal(limit: ol_geom.Geometry) {

        omnia.map.splitAlongLine(
            limit,
            this.layer.zones,
            undefined,
            (g, z) => {
                const nz = this.layer.createNewZoneWithGeometry(g)
                nz.value = z.value
            },
            this.topo
        )

    }

}
